import { useLocale } from '../contexts/LocaleContext';
import { t as translate } from '../locales/translations';
import type { Locale } from '../types';

interface UseTranslationReturn {
  t: (key: Parameters<typeof translate>[0], locale: Locale) => string;
  selectedLocale: Locale;
  setSelectedLocale: (locale: Locale) => void;
}

/**
 * Custom hook that combines locale context with translation function
 * Provides convenient access to translations and current locale
 */
export const useTranslation = (): UseTranslationReturn => {
  const { selectedLocale, setSelectedLocale } = useLocale();

  return {
    t: translate,
    selectedLocale,
    setSelectedLocale
  };
};
